export default "__VITE_ASSET__yJiC4Qju__"